import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages, FormattedMessage} from "react-intl";
import AdvertModal from "components/AdvertModal/AdvertModal";
import {connect} from "react-redux";
import {toggleModal} from "actions/modal";

const messages = defineMessages({
    no_sms: {
        id:"priceLevels.no_sms",
        defaultMessage:"I don't want to receive SMS"
    }
});

class AdvertEdit extends React.Component {
    static propTypes = {
        advert: PropTypes.object.isRequired,
        priceValuesVoice: PropTypes.array.isRequired,
        priceValuesSms: PropTypes.array.isRequired,
        serviceTypeValues: PropTypes.array.isRequired,
        onAdvertEdit: PropTypes.func.isRequired,
        open: PropTypes.bool,
        toggle: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        canHaveHappyHours: PropTypes.bool,
    };

    render() {
        const {open, advert, priceValuesVoice, priceValuesSms, serviceTypeValues, onAdvertEdit, toggle, intl, canHaveHappyHours} = this.props;

        return (
            <div>
                <a tabIndex={1} className="clickable" onClick={toggle}>
                    <FormattedMessage id="conversation.advert.edit_info" defaultMessage="Change info"/>
                </a>

                <AdvertModal serviceTypeValues={serviceTypeValues} priceValuesSms={priceValuesSms} priceValuesVoice={priceValuesVoice}
                             onAdvertFormSubmit={onAdvertEdit} advert={advert} isOpen={open}
                             onToggle={toggle} canHaveHappyHours={canHaveHappyHours}/>
            </div>
        )
    }
}

export default connect(
    state => ({
        open: state.modal.advertEdit.open,
    }),
    dispatch => ({
        toggle: (data) => dispatch(toggleModal('advertEdit', data || {}))
    })
)(injectIntl(AdvertEdit));


// WEBPACK FOOTER //
// ./src/containers/Conversations/Controls/AdvertEdit.jsx